const Reflux = require("reflux");
const RDStationIntegrationActions = require("../actions/rd-station-integration-actions");
const SignalActions = require("app/shared/actions/signal-actions");
const rdStationIntegrationAPI = require("app/util/api/rd-station-integration");

const RDStationIntegrationStore = Reflux.createStore({
  state: {
    activation: "none",
    authorizationURL: "",
    isReturningFromCallback: false,
    showSettings: false,
    settings: { event_identifiers: [] },
    isSavingSettings: false,
    eventIdentifiers: null,
    isLoadingEventIdentifiers: false
  },

  init: function() {
    this.listenTo(RDStationIntegrationActions.getStatus, this.onGetStatus);
    this.listenTo(RDStationIntegrationActions.deactivate, this.onDeactivate);
    this.listenTo(RDStationIntegrationActions.toggleSettings, this.onToggleSettings);
    this.listenTo(RDStationIntegrationActions.changeSettings, this.onChangeSettings);
    this.listenTo(RDStationIntegrationActions.saveSettings, this.onSaveSettings);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    this.state.isReturningFromCallback = window.location.href.includes("rd");

    return this.state;
  },

  onGetStatus: function() {
    rdStationIntegrationAPI.getStatus(
      this.onGetStatusCompleted,
      this.onGetStatusFailed
    );
  },

  onGetStatusCompleted: function(data) {
    if (data.active) {
      this.state.activation = "active";
    } else {
      this.state.activation = "inactive";
    }

    this.state.authorizationUrl = data.auth_url;
    this.state.settings = data.settings || {};

    if (this.state.isReturningFromCallback) {
      let message, type;

      if (data.active) {
        message = "Integração com RD Station ativada com sucesso!"
        type = "success";
      } else {
        message = "Não foi possível ativar a integração com RD Station.",
        type = "warning";
      }

      SignalActions.show({ message, type, hideTimeout: 5000 });

      // Erases the parameter from the URL so that the Signal does not appear
      // again in case of a refresh.
      history.pushState({}, document.title, "?");
      this.state.isReturningFromCallback = false;
    }

    this.trigger(this.state);
  },

  onGetStatusFailed: function(error) {
    SignalActions.show({
      message: "Não foi possível buscar o status da integração com RD Station.",
      type: "warning",
      hideTimeout: 5000
    });
  },

  onDeactivate: function() {
    this.state.activation = "deactivating";
    this.state.showSettings = false;

    this.trigger(this.state);

    rdStationIntegrationAPI.deactivate(
      this.onDeactivateCompleted,
      this.onDeactivateFailed
    );
  },

  onDeactivateCompleted: function(data) {
    SignalActions.show({
      message: "Integração com RD Station desativada.",
      hideTimeout: 5000
    });

    this.state.activation = "inactive";
    this.state.authorizationUrl = data.auth_url;
    this.state.showSettings = false;

    this.trigger(this.state);
  },

  onDeactivateFailed: function() {
    SignalActions.show({
      message: "Ocorreu um erro ao desativar a integração com RD Station.",
      type: "warning",
      hideTimeout: 5000
    });

    this.state.activation = "active";

    this.trigger(this.state);
  },

  onToggleSettings: function() {
    this.state.showSettings = !this.state.showSettings;
    this.trigger(this.state);

    if (this.shouldGetEventIdentifiers()) {
      this.onGetEventIdentifiers();
    }
  },

  onChangeSettings: function(settings) {
    this.state.settings = settings;
    this.trigger(this.state);

    if (this.shouldGetEventIdentifiers()) {
      this.onGetEventIdentifiers();
    }
  },

  onSaveSettings: function() {
    this.state.isSavingSettings = true;
    this.trigger(this.state);

    rdStationIntegrationAPI.updateSettings(
      this.state.settings,
      this.onSaveSettingsCompleted,
      this.onSaveSettingsFailed
    );
  },

  onSaveSettingsCompleted: function() {
    SignalActions.show({
      message: "Configurações da integração com RD Station salvas com sucesso!",
      type: "success",
      hideTimeout: 5000
    });

    this.state.isSavingSettings = false;
    this.trigger(this.state);
  },

  onSaveSettingsFailed: function() {
    SignalActions.show({
      message: "Não foi possível salvar suas configurações da integração com RD Station.",
      type: "warning",
      hideTimeout: 5000
    });

    this.state.isSavingSettings = false;
    this.trigger(this.state);
  },

  onGetEventIdentifiers: function() {
    this.state.isLoadingEventIdentifiers = true;
    this.trigger(this.state);

    rdStationIntegrationAPI.getEventIdentifiers(
      this.onGetEventIdentifiersCompleted,
      this.onGetEventIdentifiersFailed
    );
  },

  onGetEventIdentifiersCompleted: function(data) {
    this.state.isLoadingEventIdentifiers = false;
    this.state.eventIdentifiers = data;

    this.trigger(this.state);
  },

  onGetEventIdentifiersFailed: function() {
    SignalActions.show({
      message: "Não foi possível buscar seus eventos do RD Station.",
      type: "warning",
      hideTimeout: 5000
    });

    this.state.isLoadingEventIdentifiers = false;
    this.trigger(this.state);
  },

  shouldGetEventIdentifiers: function() {
    return (
      this.state.showSettings &&
      this.state.settings.event_type === "converted" &&
      this.state.eventIdentifiers === null
    );
  }
});

module.exports = RDStationIntegrationStore;



// WEBPACK FOOTER //
// ./app/screens/Integration/stores/rd-station-integration-store.js